<template>
  <div>
    <div class="titleArea">
      <img v-if="lecturer.thumb" class="img" :src="lecturer.thumb.url" alt="" />
      <img v-else class="img" src="@/assets/images/common/noimg.jpg" alt="" />
      <span class="name">{{ lecturer.name }}</span>
      <span class="company">
        {{ lecturer.company
        }}<br v-if="lecturer.company && lecturer.position" />{{
          lecturer.position
        }}
      </span>
    </div>
    <dt>経歴</dt>
    <dd v-html="lecturer.career"></dd>
    <dt>実績</dt>
    <dd v-html="lecturer.works"></dd>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    lecturer: Object
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.titleArea {
  display: grid;
  grid-template:
    'img ..name' 20px
    'img .. ..' 5px
    'img .. company' minmax(45px, 1fr)
    / 70px 16px 1fr;
  .img {
    grid-area: img;
    object-fit: cover;
    height: 70px;
    width: 70px;
  }
  .name {
    grid-area: name;
    font-weight: bold;
    letter-spacing: 0.02px;
  }
  .company {
    grid-area: company;
  }
}

::v-deep a {
  color: var.$color-main-text;
}
</style>
